import { requestBuilder } from '../../http/RequestBuilder';
import type { GeneralResponse } from '../../http/types/Common';
import type {
    NotificationChannel,
    NotificationType,
} from '../types/UserNotificationChannel';

interface UpdateNotificationChannelBody {
    type: NotificationType;
    channel: NotificationChannel;
    enabled: boolean;
}

const useUpdateNotificationChannel = requestBuilder.mutation<
    GeneralResponse,
    UpdateNotificationChannelBody
>({
    endpoint: '/api/user-notifications',
    method: 'PATCH',
});

export default useUpdateNotificationChannel;
